import { FC, MouseEventHandler } from 'react'
import classNames from 'classnames'
import CheckSvg from 'public/images/common/check_v2.svg'
import styles from './index.module.scss'

type Props = {
  selected?: boolean
  disabled?: boolean
  onClick: MouseEventHandler<HTMLButtonElement>
  labelHtmlFor: string
}

export const Checkbox: FC<Props> = ({ selected = false, disabled = false, onClick, labelHtmlFor }) => {
  return (
    <button
      type='button'
      className={classNames(
        styles.container,
        {
          [styles.selected]: selected,
        },
        {
          [styles.disabled]: disabled,
        }
      )}
      onClick={onClick}
      disabled={disabled}
      id={labelHtmlFor}
    >
      {selected && (
        <div className={styles.icon}>
          <CheckSvg viewBox='0 0 24 24' />
        </div>
      )}
    </button>
  )
}
